import * as React from 'react';
import isNil from 'lodash/isNil';

import OfferBannerContext from '../../context/OfferBannerContext';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./offer-banner-details-other-arrangement.i18n.json'));

import type { SubcampaignOfferStatus } from 'types';

type Props = {
  perks: string | undefined | null,
  offerState: SubcampaignOfferStatus | undefined | null
};

const MSG_KEY = 'offer_banner_details_other_arrangement';

const OfferBannerDetailsOtherArrangement: React.FC<Props> = ({
  perks,
  offerState
}: Props) => {
  const context = React.useContext(OfferBannerContext);
  const { isRenegotiation } = context;

  if (isNil(perks) || isNil(offerState)) {
    return null;
  }

  const labelKey = offerState === 'pending' ? 'new_offer' : 'agreed_offer';
  const label = isRenegotiation || offerState === 'pending'
    ? `${__t(`${MSG_KEY}.labels.${labelKey}`)}: `
    : '';

  const text = `${label}${perks}`;

  return (
    <div
      className="offer-banner-details-other-arrangement"
      title={text}
    >
      {text}
    </div>
  );
};

export default OfferBannerDetailsOtherArrangement;
